import { render } from "./GoogleAnalyticComponent.vue?vue&type=template&id=604c409c"
import script from "./GoogleAnalyticComponent.vue?vue&type=script&lang=js"
export * from "./GoogleAnalyticComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__